import React from 'react';
import { motion } from 'framer-motion';
import { 
  DocumentDuplicateIcon,
  PaintBrushIcon,
  ArrowDownTrayIcon,
  ClockIcon,
  ShareIcon,
  CogIcon
} from '@heroicons/react/24/outline';

const CustomReportsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center mb-4">
              <DocumentDuplicateIcon className="h-8 w-8 text-purple-600 mr-3" />
              <h1 className="text-3xl font-bold text-gray-900">Custom Reports</h1>
            </div>
            <p className="text-lg text-gray-600">
              White-label reports and custom branding for your business needs.
            </p>
          </motion.div>
        </div>

        {/* Coming Soon Card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center"
        >
          <div className="max-w-md mx-auto">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <DocumentDuplicateIcon className="h-8 w-8 text-purple-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Coming Soon</h2>
            <p className="text-gray-600 mb-6">
              We're building powerful custom reporting tools to help you create branded reports for your clients.
            </p>
            <div className="space-y-4 text-left">
              <div className="flex items-center text-gray-700">
                <PaintBrushIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>White-label branding</span>
              </div>
              <div className="flex items-center text-gray-700">
                <CogIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Custom templates</span>
              </div>
              <div className="flex items-center text-gray-700">
                <ArrowDownTrayIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Multiple export formats</span>
              </div>
              <div className="flex items-center text-gray-700">
                <ClockIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Scheduled delivery</span>
              </div>
              <div className="flex items-center text-gray-700">
                <ShareIcon className="h-5 w-5 text-purple-500 mr-3" />
                <span>Client sharing</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default CustomReportsPage;
